import * as Yup from 'yup';
import { maxText } from '../../shared/utils/input-regex';

export const ForgotPasswordValidationSchema = Yup.object().shape({
  userName: Yup.string()
    .email('Email format is incorrect')
    .required('Email address is required')
    .max(320, `${maxText}  320 `),
});
